/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ThreadOut {
  id: string;
  level: string;
  entity_id: string | null;
  data_class: string;
  retention_class: string;
  retention_recording_until: string | null;
  retention_transcript_until: string | null;
  write_back_blocked: boolean;
  block_reason: string | null;
}
